import React, { memo } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ErrorBoundary from '../components/ErrorBoundary';
import AdminDashboard from '../components/AdminDashboard';

const AuthenticatedRoutes = ({ userEmail, userFirstName, userLastName, hasAdminAccess }) => {
  // Redirect users without admin access
  if (!hasAdminAccess) {
    return <Navigate to="/unauthorized" replace />;
  }

  // Admin app shows admin dashboard for authenticated users with admin access
  return (
    <Routes>
      {/* All admin routes handled by AdminDashboard component */}
      <Route
        path="/*"
        element={
          <ErrorBoundary>
            <AdminDashboard
              userEmail={userEmail}
              userFirstName={userFirstName}
              userLastName={userLastName}
              hasAdminAccess={hasAdminAccess}
            />
          </ErrorBoundary>
        }
      />
    </Routes>
  );
};

export default memo(AuthenticatedRoutes);